import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import Helmet from "react-helmet"
import Header from "./header"
import Footer from "./footer"

import "../styles/main.scss"

class Layout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      scrollable: true,
    }
    this.toggleScrollable = this.toggleScrollable.bind(this)
  }

  toggleScrollable(force) {
    const { scrollable } = this.state
    this.setState({
      scrollable: typeof force === "boolean" ? force : !scrollable,
    })
  }

  render() {
    const { children, className, headerSeparator } = this.props
    const { scrollable } = this.state
    const scrollClass = scrollable ? "" : "disable-scroll"

    return (
      <StaticQuery
        query={graphql`
          query HeadingQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={(data) => (
          <div className="main">
            <Helmet>
              <html lang="en" className={scrollClass} />
              <title>{data.site.siteMetadata.title}</title>
              <body className={scrollClass} />
            </Helmet>
            <div className="hard-limit">
              <Header
                toggleScrollable={this.toggleScrollable}
                separator={headerSeparator}
              />
              <main className={`main-content ${className}`}>{children}</main>
              <Footer />
            </div>
          </div>
        )}
      />
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  headerSeparator: PropTypes.bool,
}

Layout.defaultProps = {
  headerSeparator: false,
}

export default Layout
